import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import React from 'react';

import EmptyContent from '../../../public/images/empty-content.svg';

export default function NoResults(props: any) {
  const searchKeyword = props.keyword;
  const title = ['Your search - ', ' - did not match any items.'];
  const description = `
    <p>Suggestions:</p>
    <p>Make sure that all words are spelled correctly.</p>
    <p>Try different keywords.</p>
    <p>Try more general keywords.</p>`;
  return (
    <Box h='100vh'>
      <Grid justifyContent={{ lg: 'center' }} gridAutoFlow={{ lg: 'row', xl: 'column' }} gridColumnGap='l'>
        <GridItem maxW='400px'>
          <Box pb='s'>
            <Text textStyle={{ base: 'mobile.h5', lg: 'desktop.h5' }} as='span' color='mountain.base'>
              <> {title[0]} </>
              <Text textStyle={{ base: 'mobile.h5', lg: 'desktop.h5' }} color='cyan.ramboll' as='span'>
                {searchKeyword}
              </Text>
              <> {title[1]} </>
            </Text>
          </Box>
          <Box textStyle='desktop.body.s' dangerouslySetInnerHTML={{ __html: description }} />
        </GridItem>
        <GridItem mb='100px'>
          <EmptyContent width='100%' viewBox='0 0 700 300' />
        </GridItem>
      </Grid>
    </Box>
  );
}
